import { defineComponent } from "vue";

import { HospiceReferral } from "../../../../../resources-vue/vue-models/hospice-referral";

import PatientPreadmissionNotes from "../../../../CreateReferral/CreateReferralHosPal/components/PatientPreadmissionNotes/PatientPreadmissionNotes.vue";

export default defineComponent({
    inject: ["dialogRef"],
    components: { PatientPreadmissionNotes },
    name: "HosPalPreadmissionNotes",
    data(vm) {
        return {
            dialogReference: this.dialogRef as any,
            application: null as number,
            accountId: null,
            referralId: null,
            referral: null
        };
    },
    mounted() {
        this.referral = new HospiceReferral(
            this.dialogReference.data.referral.application,
            this.dialogReference.data.referral
        );
        this.application = this.dialogReference.data.referral.application;
        this.accountId = this.dialogReference.data.referral.accountId;
        this.referralId = this.dialogReference.data.referral.id;
    },
    methods: {
        closePreadmissionDialog(shouldRefresh: boolean) {
            this.dialogReference.close(shouldRefresh ? "refresh" : null);
        }
    }
});
